import { ComponentType } from "react";
import { SubModalType } from "Types/state";
import { ModalComponentProps } from ".";
import ApologiesModal from "./Components/ApologiesModal";
import UnableToSubmitCreditAppApologyModal from "./Components/ApologiesModal/UnableToSubmitCreditAppApology";
import VehicleLimitApologiesModal from "./Components/ApologiesModal/vehicleLimitApology";
import BadDealApologiesModal from "./Components/BadDealApologiesModal";
import CustomModal from "./Components/CustomModal";
import PaymentPlanReviewModal from "./Components/PaymentPlanReviewModal";
import UnexpectedErrorModal from "./Components/UnexpectedErrorModal";

const modalTypes: { [K in SubModalType]: ComponentType<ModalComponentProps> } = {
    apologiesModal: ApologiesModal,
    badDealApologiesModal: BadDealApologiesModal,
    customModal: CustomModal,
    paymentPlanReviewModal: PaymentPlanReviewModal,
    unableToSubmitCreditAppApologyModal: UnableToSubmitCreditAppApologyModal,
    unexpectedErrorModal: UnexpectedErrorModal,
    vehicleLimitApologiesModal: VehicleLimitApologiesModal,
};

export default modalTypes;
